import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../modules/utils/fetchWithHandlingLoginRedirect'
import moment from 'moment'

export default class IndexController extends Controller {
  // semantics ui multiple dropdown fields trigger onChange event for each removal of value. This flag is used to prevent multiple events
  isFilterDisabled = false

  static targets = [
    'table',
    'loadingIcon'
  ]

  static values = {
    filterSetKeyPrefix: String
  }

  connect () {
    if (!this.filterSetKeyPrefixValue) {
      throw new Error('filterSetKeyPrefixValue is required')
    }

    if (!this.loadingIconTarget) {
      throw new Error('loadingIconTarget is required')
    }
  }

  paginate (event) {
    const filters = this.buildFilters()

    const searchInputValue = $('.search-input').val()
    if (searchInputValue !== undefined && searchInputValue !== '') {
      filters.criteria[this.filterSetKeyPrefixValue + '_search'] = searchInputValue
    }

    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].page = event.detail.page

    this.fetchResults(filters)
  }

  searchText (event) {
    const searchText = event.detail.searchText
    const filters = this.buildFilters()
    filters.criteria[this.filterSetKeyPrefixValue + '_search'] = searchText

    this.fetchResults(filters)
  }

  filter (event) {
    if (!this.isFilterDisabled) {
      const filters = this.buildFilters()
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].page = 1

      const searchText = $('.search-input').val()
      if (searchText) {
        filters.criteria[this.filterSetKeyPrefixValue + '_search'] = searchText
      }

      this.fetchResults(filters)

      if (event.params.lozengeElementId) {
        this.updateFilterLozenge(
          event.currentTarget,
          event.params.lozengeElementId
        )
      }
    }
  }

  getUrl () {
    let url = this.filterSetKeyPrefixValue

    if (url === 'search_archived_logs_report') {
      url = 'records'
    }

    if (url === 'form_templates') {
      url = 'form-templates'
    }

    if (url.startsWith('forms_')) {
      url = 'forms'
    }

    return url
  }

  buildFilters () {
    return { criteria: { [this.filterSetKeyPrefixValue + '_filters']: {}, filter_set_key_prefix: this.filterSetKeyPrefixValue } }
  }

  /** if filters present, page number goes under filters, if not we send it via queryParam */
  fetchResults (filters, pageViaQueryParam = undefined) {
    this.tableTarget.style.opacity = 0.1
    $(this.loadingIconTarget).show()

    let url = this.getUrl()
    url += '?partial=table'
    if (pageViaQueryParam) {
      url += `&page=${pageViaQueryParam}`
    }

    if (this.filterSetKeyPrefixValue.startsWith('forms_')) {
      const formTemplateId = this.filterSetKeyPrefixValue.replace('forms_', '')
      url += `&template_id=${formTemplateId}`
    }

    fetchWithHandlingLoginRedirect(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(filters)
    }).then(response => {
      response.text().then(text => {
        this.tableTarget.style.opacity = 1
        $(this.loadingIconTarget).hide()
        this.tableTarget.innerHTML = text

        // Retrieve the value of isPageOutOfRangeReload
        const isPageOutOfRangeReload = document.getElementById('is-page-out-of-range-reload')?.dataset?.value === 'true'

        if (isPageOutOfRangeReload) {
          $('#page-out-of-range-reload').removeClass('d-none')
        }
      })
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error:', error)
    })
  }

  disableFilterEvents () {
    this.isFilterDisabled = true
  }

  enableFilterEvents () {
    this.isFilterDisabled = false
  }

  removeFilter (event) {
    const filterKey = event.params.filterKey

    if (filterKey) {
      if ($(`[data-filter-key="${filterKey}"]`).hasClass('dropdown')) {
        this.disableFilterEvents()
        // already existing stimulus on change event will be triggered multiple times, because, "dropodown clear" does not set empty array, but removes item by item and causes multiple events
        $(`[data-filter-key="${filterKey}"]`).dropdown('clear')
        this.enableFilterEvents()
      }

      if ($(`[data-filter-key="${filterKey}"]`).hasClass('checkbox')) {
        $(`[data-filter-key="${filterKey}"]`).checkbox('uncheck')
      }

      if ($(`[data-filter-key="${filterKey}"]`).hasClass('datepicker')) {
        this.disableFilterEvents()
        $(`[data-filter-key="${filterKey}"]`).datepicker('clearDates')
        this.enableFilterEvents()
      }
    }

    const filters = this.buildFilters()
    this.fetchResults(filters)

    $(event.target).parent('.filter-container').fadeOut()
  }

  clearFilters () {
    this.setUIFilterDefaults()
    const clearFilters = this.buildFilters()
    this.fetchResults(clearFilters)
    $('.filter-container').fadeOut()
  }

  updateFilterLozenge (currentElement, lozengeElementId) {
    const lozengeForUpdate = $('#' + lozengeElementId)

    if ($(currentElement).hasClass('dropdown')) {
      const semanticUiElement = $(currentElement).parent()
      if (semanticUiElement.dropdown('get values')) {
        const selectedValues = semanticUiElement.dropdown('get values')
        const selectedLabels = Array.isArray(selectedValues)
          ? selectedValues.map(value => semanticUiElement.dropdown('get item', value).data('name'))
          : [semanticUiElement.dropdown('get item', selectedValues).data('name') ?? selectedValues]
        $(lozengeForUpdate).fadeIn()
        $(lozengeForUpdate).find('.filter-text-value').text(selectedLabels.join(', '))

        if (lozengeElementId.startsWith('record-type-') && selectedValues !== 'ISSUE') {
          const nonIssueFilters = ['categories', 'priorities', 'locations', 'resolutions']

          nonIssueFilters.forEach(filter => {
            const issueLozengeId = `${filter}-filterContainer`
            const issueLozenge = $(`#${issueLozengeId}`)
            if (issueLozenge.length) {
              issueLozenge.fadeOut()
            }
          })
        }
      } else {
        $(lozengeForUpdate).fadeOut()
      }
    }

    if ($(currentElement).hasClass('checkbox')) {
      if ($(currentElement).checkbox('is checked')) {
        $(lozengeForUpdate).fadeIn()
        $(lozengeForUpdate).find('.filter-text-value').text('on')
      } else {
        $(lozengeForUpdate).fadeOut()
      }
    }

    if ($(currentElement).hasClass('datepicker')) {
      const accountDateFormat = localStorage.getItem('accountDateFormat')
      const date = $(currentElement).data('datepicker').getDate()
      const formattedDate = moment(date).format(accountDateFormat.toUpperCase())
      lozengeForUpdate.fadeIn()
      $(lozengeForUpdate).find('.filter-text-value').text(formattedDate)
    }
  }

  setUIFilterDefaults () {
    // do nothing
  }

  // this can be used via mixins
  clearDates () {
    this.disableFilterEvents()
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()

    const filters = this.buildFilters()

    this.fetchResults(filters)

    $('#from-date-filterContainer').fadeOut()
    $('#to-date-filterContainer').fadeOut()
  }

  initializeFromToDateFilters () {
    const datepickerOptions = {
      autoclose: true,
      format: accountDateFormat,
      zIndexOffset: '2000'
    }

    // Integrate the datepicker functionality into Stimulus controller
    $('#from-date-filter, #to-date-filter').datepicker(datepickerOptions).on('changeDate', function (e) {
      if (e.date == null) {
        return
      }

      const event = new Event('dateChanged')
      this.dispatchEvent(event)
    })
  }
}
